<template>
    <a :href="href" :target="target"
        :class="` text-cta-contrast-500 bg-cta-500  font-[500] flex justify-center items-center rounded-xl w-full py-2 px-[20px] hover:shadow duration-100 hover:bg-cta-400 h-[40px]`">
        <slot />
    </a>
</template>
<script>
import { Link } from '@inertiajs/vue3';

export default {
    components:{
        Link
    },
    props: {
        href: String,
        target: String
    }
}
</script>
